<template>
<v-layout>
  <v-flex xs12>
  <v-card>
    <v-card-title>
      <v-btn color="info" href="#/advertiser/addUrl" @click="goToAdd()">Add Advertiser Url</v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="advertiserUrls"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        
        <td class="text-xs-left">{{ props.item.advertiserUrlId }}</td>
        <td class="text-xs-left">{{ props.item.advertiserName }}</td>
        <td class="text-xs-left">{{ props.item.countryName }}</td>
        <td class="text-xs-left">{{ props.item.operatorName }}</td>

        <td class="text-xs-left">{{ props.item.trafficType }}</td>
        <td class="text-xs-left">{{ props.item.modelType }}</td>
        <td class="text-xs-left">{{ props.item.advertiserCampaignName }}</td>

        <td class="text-xs-left">{{ props.item.advertiserUrl }}</td>
        <td class="text-xs-left">{{ props.item.cpa }}</td>

        <td class="text-xs-center">{{ props.item.status? 'Active' : 'Inactive' }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editAdvertiserUrl(props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteAdvertiserUrl(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Sorry!!! No result found for your search "{{ search }}".
      </v-alert>
    </v-data-table>
  </v-card>
  </v-flex>

  <v-flex v-if="deleteDialog">
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="title">Do you want to change the status of the advertiser url?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" outline @click.native="deleteDialog = false; selectedAdvertiserUrl = null">Cancel</v-btn>
          <v-btn color="primary" outline @click.native="deleteConfirmed()">Change</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>


  </v-layout>
</template>
<script>
import axios from "axios";
import { SERVER_URL } from "./../../constant.js";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Adv. Url ID",
          value: "advertiserUrlId",
          align: "left"
        },
        {
          text: "Advertiser Name",
          value: "advertiserName",
          align: "left"
        },
        {
          text: "Country Name",
          align: "left",
          value: "countryName",
          sortable: false
        },
        {
          text: "Operator Name",
          align: "left",
          value: "operatorName",
          sortable: false
        },
        {
          text: "Traffic Type",
          align: "left",
          value: "trafficType",
          sortable: false
        },
        {
          text: "Model Type",
          align: "left",
          value: "modelType",
          sortable: false
        },
        {
          text: "Campaign Name",
          align: "left",
          value: "advertiserCampaignName",
          sortable: false
        },
        {
          text: "AdvertiserUrl",
          align: "left",
          value: "advertiserUrl",
          sortable: false
        },
        {
          text: "CPA",
          align: "left",
          value: "cpa",
          sortable: false
        },
        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: false
        }
      ],
      advertiserUrls: [],

      deleteDialog: false,
      selectedAdvertiserUrl: null

    };
  },
  created() {
    document.title = 'Advertiser Urls';
    axios.get(`${SERVER_URL}/advertiser/allUrl`).then(res => {
      this.advertiserUrls = res.data;
    });
  },
  methods: {
    goToAdd() {
      this.$router.push("/advertiser/addurl");
    },
    deleteAdvertiserUrl(advertiserUrl) {
      this.selectedAdvertiserUrl = advertiserUrl;
      this.deleteDialog = true;
    },
    
    editAdvertiserUrl (advertiserUrl) {
      this.$router.push(`/advertiser/editUrl/${advertiserUrl.id}`);
    },
    deleteConfirmed() {
      
      let advertiserUrl = this.selectedAdvertiserUrl;

      advertiserUrl.status = ! advertiserUrl.status;

      this.deleteDialog = false;

      axios
      .post(`${SERVER_URL}/advertiser/url/update`, advertiserUrl)
      .then(res => {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Advertiser Url Deleted Successfully"
        });

        document.dispatchEvent(showSnackbarEvent);
        var changedIndex = this.advertiserUrls.findIndex(
          advUrl =>
            advUrl.advertiserUrlId === advertiserUrl.advertiserUrlId
        );
        this.$set(this.advertiserUrls, changedIndex, advertiserUrl);
        this.selectedAdvertiserUrl = null;

      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/advertiser/ListAdvertiserUrls.vue